import { Card } from "@mui/material";
import React from "react";
import Chart from "react-apexcharts";
import { AppUtils } from "../../../utils/appUtils";
import MessageBlock from "../../../pages/admin/components/message-block/MessageBlock";
import { NO_RECORDS_FOUND } from "../../../utils/constants";

const ChartDataBySewaType = ({ chartDataBySewa }) => {
  const serviceData = chartDataBySewa?.SERVICE_DATA || {};

  // Convert serviceData object into arrays
  const seriesData = Object.values(serviceData);

  const chartOptions = {
    chart: {
      type: "pie",
      toolbar: {
        show: true,
        tools: {
          download: true,
        },
      },
    },
    labels: ["सामान्य उपचार", "पञ्चकर्म  सेवा", "शल्य सेवा ", "योग सेवा", "जेष्ठ नागरिक सेवा", "स्तनपायी आमा तथा मातृशिशु सेवा", "अकुपञ्चर सेवा", "फिजियोथेरापी सेवा", "होमियोप्याथी सेवा", "प्राकृतिक चिकित्सा सेवा", "सोवारिग्पा (आम्ची)  चिकित्सा सेवा", "नसर्ने रोग तथा मानसिक स्वास्थ्य सेवा", "अन्य सेवा"],
    plotOptions: {
      pie: {
        startAngle: -90,
        endAngle: 270,
        monochrome: {
          enabled: true,
          color: "#255aee",
          shadeTo: "light",
          shadeIntensity: 0.65,
        },
      },
    },
    dataLabels: {
      enabled: true,
      style: {
        colors: ["#fff"],
        fontSize: '15px',
      },
    },
    tooltip: {
      enabled: true,
      y: {
        formatter: (val) => `${AppUtils.replaceWithNepaliDigit(val)} जना`
      }
    },
    title: {
      text: "सेवाको प्रकारअनुसार चालु आ. व. को जम्मा सेवाग्राहिहरु",
      align: "center",
      style: {
        fontSize: "15px",
      },
    },
    responsive: [{
      breakpoint: 480,
      options: {
        chart: {
          width: 200
        },
        legend: {
          position: "bottom",
        }
      }
    }],
  };

  return (
    <>
      <Card>
        <Card>
          {seriesData.some((value) => value > 0) ? (
            <Chart
              options={chartOptions}
              series={seriesData}
              type="pie"
              height={700}
            />
          ) : (
            <MessageBlock text={NO_RECORDS_FOUND} />
          )}
        </Card>
      </Card>
    </>
  );
};

export default ChartDataBySewaType;